import * as React from 'react';
import { useState, createContext, useContext } from 'react';
import { RitverktygTyp } from '../model/KartstodModel';

interface PremiumContextTyp {
  ritverktyg: RitverktygTyp;
  setRitverktyg: (ritverktyg: RitverktygTyp) => void;
  buffertRadie: string;
  setBuffertRadie: (buffertRadie: string) => void;
  geometri: string;
  setGeometri: (b: string) => void;
  isRitverktygAktiv: boolean;
  setIsRitverktygAktiv: (b: boolean) => void;
  isInstallningarAktiv: boolean;
  setIsInstallningarAktiv: (b: boolean) => void;
  isMarkeraAktiv: boolean;
  setIsMarkeraAktiv: (b: boolean) => void;
}

const PremiumContext = createContext<PremiumContextTyp | undefined>(undefined);

type PremiumContextProviderProps = { children: React.ReactNode };

function PremiumProvider({ children }: PremiumContextProviderProps) {
  const [ritverktyg, setRitverktyg] = useState<RitverktygTyp>({
    isCirkel: false,
    isPolygon: false,
    isLinje: false,
    isPin: false,
  });
  const [geometri, setGeometri] = useState('pin');
  const [buffertRadie, setBuffertRadie] = useState('');
  const [isRitverktygAktiv, setIsRitverktygAktiv] = useState(false);
  const [isInstallningarAktiv, setIsInstallningarAktiv] = useState(false);
  const [isMarkeraAktiv, setIsMarkeraAktiv] = useState(false);

  const value = {
    ritverktyg,
    setRitverktyg,
    buffertRadie,
    setBuffertRadie,
    geometri,
    setGeometri,
    isRitverktygAktiv,
    setIsRitverktygAktiv,
    isInstallningarAktiv,
    setIsInstallningarAktiv,
    isMarkeraAktiv,
    setIsMarkeraAktiv,
  };

  return (
    <PremiumContext.Provider value={value}>{children}</PremiumContext.Provider>
  );
}

function usePremiumContext() {
  const context = useContext(PremiumContext);
  if (context === undefined) {
    throw new Error('React must be used within a PremiumContextProvider');
  }
  return context;
}

export { PremiumProvider, usePremiumContext };
